module.exports = __webpack_public_path__ + "static/media/regular.45b5f5d5.eot";